<template>
  <div>
    <h4 class="slds-tree__group-header" id="treeheading" v-if="section.header">{{ $t (section.header) }}</h4>
    <ul aria-labelledby="treeheading" class="slds-tree" role="tree">
      <li
        role="treeitem"
        v-for="(item, index) in section.sections"
        :aria-expanded="index === expandedSectionIndex"
        :aria-label="$t(item.label)"
        :aria-level="level"
        :aria-selected="$route.path.includes(item.route)"
        :key="item.label"
        @click="toggleSection($event, index)">

        <div class="slds-tree__item">
          <button
            :class="{'slds-is-disabled': !item.sections}"
            class="slds-button slds-button_icon slds-m-right_x-small"
            aria-hidden="true"
            tabindex="-1">
            <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
              <use xlink:href="../../assets/symbols.svg#chevronright"></use>
            </svg>
          </button>
          <span class="slds-has-flexi-truncate">
            <router-link tag="span" :to="item.route" class="slds-tree__item-label slds-truncate" v-if="!item.sections">
              {{ $t(item.label) }}
            </router-link>
            <span class="slds-tree__item-label slds-truncate" :title="$t(item.label)" v-else>{{ $t(item.label) }}</span>
          </span>
        </div>
        <ul role="group" v-if="item.sections">
          <menu-item :level="level + 1" :section="item" />
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'menu-item',
  data () {
    return {
      expandedSectionIndex: -1
    }
  },
  methods: {
    toggleSection (event, index) {
      if (this.expandedSectionIndex === index) {
        this.expandedSectionIndex = -1
      } else {
        this.expandedSectionIndex = index
      }
      event.stopPropagation()
    }
  },
  props: {
    level: Number,
    section: Object
  }
}
</script>
<style lang="scss" scoped>

</style>
